import { render, staticRenderFns } from "./servicios_extras.vue?vue&type=template&id=43d448d8"
import script from "./servicios_extras.js?vue&type=script&lang=js&external"
export * from "./servicios_extras.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports